angular
    .module('dnecom.component.cart')
    .factory('Cart', ["$rootScope", "$http", "$q", "CartHash", "StoreRoute", function($rootScope, $http, $q, CartHash, StoreRoute) {
        var carts = {};

        var deferredQueue = [];

        var loadingDeferredQueue = [];

        var initializingNew = false;

        var loadingCart = false;

        var updating = {};

        $rootScope.$on('cart.loaded', function ($event, cart) {
            if (cart.hash) {
                loadingCart = false;

                var queue = _.filter(loadingDeferredQueue, function (value) {
                    return cart.hash == value.hash;
                });

                loadingDeferredQueue = _.filter(loadingDeferredQueue, function (value) {
                    return cart.hash != value.hash;
                });

                if (queue && queue.length > 0) {
                    var value;

                    while (value = queue.pop()) {
                        value.deferred.resolve(cart);
                    }
                }
            }
        });

        $rootScope.$on('cart.initialization.success', function ($event, cart) {
            initializingNew = false;

            if (cart.hash) {
                if (deferredQueue && deferredQueue.length > 0) {
                    var deferred;

                    while (deferred = deferredQueue.pop()) {
                        deferred.resolve(cart);
                    }
                }

                deferredQueue = [];
            }

            $rootScope.$broadcast('cart.loaded', cart);
        });

        $rootScope.$on('cart.initialization.fail', function ($event, response) {
            initializingNew = false;

            if (deferredQueue && deferredQueue.length > 0) {
                var deferred;

                while (deferred = deferredQueue.pop()) {
                    deferred.reject(response);
                }
            }

            deferredQueue = [];
        });

        $rootScope.$on('cart.failed', function ($event, hash, response, clearCart) {
            var queue = _.filter(loadingDeferredQueue, function (value) {
                return hash == value.hash;
            });

            loadingDeferredQueue = _.filter(loadingDeferredQueue, function (value) {
                return hash != value.hash;
            });

            if (queue && queue.length > 0) {
                var value;

                while (value = queue.pop()) {
                    value.deferred.reject(response);
                }
            }

            if (clearCart) {
                CartHash.unset();
            }

            console.log("Failed to load cart: " + hash);
        });

        $rootScope.$on('cart.update.start', function (hash) {
            if (!updating[hash]) {
                updating[hash] = 0;
            }

            updating[hash]++;
        });

        $rootScope.$on('cart.update.end', function (hash) {
            if (!updating[hash]) {
                updating[hash] = 1;
            }

            updating[hash]--;

            if (updating[hash] === 0) {
                $rootScope.$broadcast('cart.update.finish', hash);
            }
        });

        var fetch = function (deferred, hash) {
            if (!hash) {
                deferred.reject({});
                console.log('Cart not defined.');
                return;
            }

            if (loadingCart) {
                loadingDeferredQueue.push({ hash: hash, deferred: deferred });
                return;
            }

            if (!carts[hash]) {
                loadingCart = true;

                $http.get(StoreRoute.generate('stores_fe_api_cart_show', { hash: hash })).then(function (response) {
                    if (response.data.success) {
                        if (response.data.cart.hash !== hash) {
                            CartHash.set(response.data.cart.hash);
                            hash = response.data.cart.hash;
                        }

                        carts[hash] = response.data.cart;
                        deferred.resolve(response.data.cart);
                        $rootScope.$broadcast('cart.loaded', response.data.cart);
                    } else {
                        deferred.reject(response);
                        $rootScope.$broadcast('cart.failed', hash, response, true);
                    }
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.failed', hash, response, false);
                });
            } else {
                deferred.resolve(carts[hash]);
            }
        };

        return {
            get: function (hash) {
                var deferred = $q.defer();

                hash = hash || CartHash.get();

                if (!hash) {
                    if (!initializingNew) {
                        initializingNew = true;

                        $http.post(StoreRoute.generate('stores_fe_api_cart_new'), {}).then(function (response) {
                            if (response.data.success) {
                                CartHash.set(response.data.cart.hash);
                                carts[CartHash.get()] = response.data.cart;
                                $rootScope.$broadcast('cart.initialization.success', response.data.cart);
                                deferred.resolve(response.data.cart);
                            } else {
                                deferred.reject(response);
                                $rootScope.$broadcast('cart.initialization.fail', response);
                                console.log('Failed to init new cart.');
                            }
                        }, function (response) {
                            deferred.reject(response);
                            $rootScope.$broadcast('cart.initialization.fail', response);
                            console.log('Failed to init new cart.');
                        });
                    } else {
                        deferredQueue.push(deferred);
                    }
                } else {
                    fetch(deferred, hash);
                }

                return deferred.promise;
            },

            addItem: function (productId, variantId, quantity, hash) {
                $rootScope.$broadcast('cart.update.start', hash);

                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(
                            StoreRoute.generate('stores_fe_api_cart_add_item', { hash: cart.hash }),
                            {
                                product: productId,
                                variant: variantId,
                                quantity: quantity
                            }
                        )
                        .then(function (response) {
                            if (response.data.success) {
                                carts[cart.hash] = response.data.cart;
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        })
                        .finally(function () {
                            $rootScope.$broadcast('cart.update.end', hash);
                        });
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.update.end', hash);
                });

                return deferred.promise;
            },

            updateQuantities: function (quantities, hash) {
                $rootScope.$broadcast('cart.update.start', hash);

                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(
                            StoreRoute.generate('stores_fe_api_cart_update_quantities', { hash: cart.hash }),
                            {
                                quantities: quantities
                            }
                        )
                        .then(function (response) {
                            if (response.data.success) {
                                carts[cart.hash] = response.data.cart;
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        })
                        .finally(function () {
                            $rootScope.$broadcast('cart.update.end', hash);
                        });
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.update.end', hash);
                });

                return deferred.promise;
            },

            removeItem: function (id, hash) {
                $rootScope.$broadcast('cart.update.start', hash);

                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .delete(StoreRoute.generate('stores_fe_api_cart_remove_item', { hash: cart.hash, itemId: id }))
                        .then(function (response) {
                            if (response.data.success) {
                                carts[cart.hash] = response.data.cart;
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        })
                        .finally(function () {
                            $rootScope.$broadcast('cart.update.end', hash);
                        });
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.update.end', hash);
                });

                return deferred.promise;
            },

            checkPromoCode: function (code, email, hash) {
                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(StoreRoute.generate('stores_fe_api_cart_check_promo_code', { hash: cart.hash }), { code: code, email: email })
                        .then(function (response) {
                            if (response.data.success) {
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        });
                }, function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },

            applyPromoCode: function (code, email, hash) {
                $rootScope.$broadcast('cart.update.start', hash);

                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(StoreRoute.generate('stores_fe_api_cart_apply_promo_code', { hash: cart.hash }), { code: code, email: email })
                        .then(function (response) {
                            if (response.data.success) {
                                carts[cart.hash] = response.data.cart;
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        })
                        .finally(function () {
                            $rootScope.$broadcast('cart.update.end', hash);
                        });
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.update.end', hash);
                });

                return deferred.promise;
            },

            removePromoCode: function (hash) {
                $rootScope.$broadcast('cart.update.start', hash);

                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .delete(StoreRoute.generate('stores_fe_api_cart_remove_promo_code', { hash: cart.hash }))
                        .then(function (response) {
                            if (response.data.success) {
                                carts[cart.hash] = response.data.cart;
                                deferred.resolve(carts[cart.hash]);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        })
                        .finally(function () {
                            $rootScope.$broadcast('cart.update.end', hash);
                        });
                }, function (response) {
                    deferred.reject(response);
                    $rootScope.$broadcast('cart.update.end', hash);
                });

                return deferred.promise;
            },

            checkShipping: function (address, hash) {
                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(StoreRoute.generate('stores_fe_api_cart_check_shipping', { hash: cart.hash }), address)
                        .then(function (response) {
                            if (response.data.success) {
                                deferred.resolve(response);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        });
                }, function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },

            calculateShipping: function (country, state, hash) {
                var deferred = $q.defer();

                this.get(hash).then(function (cart) {
                    $http
                        .post(StoreRoute.generate('stores_fe_api_cart_calculate_shipping', { hash: cart.hash }), { country: country, state: state })
                        .then(function (response) {
                            if (response.data.success) {
                                deferred.resolve(response.data.shipping);
                            } else {
                                deferred.reject(response);
                            }
                        }, function (response) {
                            deferred.reject(response);
                        });
                }, function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },

            alwaysGet: function (hash) {
                var deferred = $q.defer();
                hash = hash || CartHash.get();

                if (hash) {
                    this.get(hash).then(function (cart) {
                        deferred.resolve({success: true, cart: cart});
                    }, function (response) {
                        deferred.resolve({success: false});
                    });
                } else {
                    deferred.resolve({success: false});
                }

                return deferred.promise;
            },

            isUpdating: function (hash) {
                hash = hash || CartHash.get();

                if (!hash) {
                    return false;
                }

                if (!updating[hash]) {
                    return false;
                }

                return updating[hash] !== 0;
            }
        };
    }]);
